<template>
  <v-container class="grey lighten-4" fluid>
    <v-container>
      <v-row align="stretch" justify="center">
        <v-col class="text-center" cols="6" sm="3" lg="3" outline>
          <v-card class="card-responsive elevation-0 grey lighten-4">
            <v-img
              class="white--text align-end"
              height="100px"
              :src="require('../assets/SQM-Stored-min.png')"
              contain
            >
              <v-card-title>1</v-card-title>
            </v-img>

            <v-card-text class="text--primary">
              <h2 class="orange--text mb-2">2,000+</h2>
              <h2 class="grey--text text--darken-2 mb-2">SQM Stored</h2>
            </v-card-text>
          </v-card>
        </v-col>
        <v-col class="text-center" cols="6" sm="3" lg="3">
          <v-card class="card-responsive elevation-0 grey lighten-4">
            <v-img
              class="white--text align-end"
              height="100px"
              :src="require('../assets/Items-Managed-min.png')"
              contain
            >
              <v-card-title>2</v-card-title>
            </v-img>

            <v-card-text class="text--primary">
              <h2 class="orange--text mb-2">21,000+</h2>
              <h2 class="grey--text text--darken-2 mb-2">Items Managed</h2>
            </v-card-text>
          </v-card>
        </v-col>
        <v-col class="text-center" cols="6" sm="3" lg="3">
          <v-card class="card-responsive elevation-0 grey lighten-4">
            <v-img
              class="white--text align-end"
              height="100px"
              :src="require('../assets/500-Customer-Reviews-min.png')"
              contain
            >
              <v-card-title>3</v-card-title>
            </v-img>

            <v-card-text class="text--primary">
              <h2 class="orange--text mb-2">500+</h2>
              <h2 class="grey--text text--darken-2 mb-2">
                Customers Served 100+
              </h2>
            </v-card-text>
          </v-card>
        </v-col>
        <v-col class="text-center" cols="6" sm="3" lg="3">
          <v-card class="card-responsive elevation-0 grey lighten-4">
            <v-img
              class="white--text align-end"
              height="100px"
              :src="require('../assets/5-stars-review-min.png')"
              contain
            >
              <v-card-title>4</v-card-title>
            </v-img>

            <v-card-text class="text--primary">
              <h2 class="orange--text mb-2">100+</h2>
              <h2 class="grey--text text--darken-2 mb-2">
                5-Star Reviews
              </h2>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
    <v-row align="center" justify="center">
      <v-col class="text-center" cols="12" sm="8">
        <p>
          Over the course of 3 years, we have served both individual and
          institutional customers from various industries. With this diverse
          clientele, we have experience in storing a wide range of items like
          documents, furniture, and merchandise, just to name a few. Our storage
          experts work closely together with our clients to find the best
          solution that is custom-fit for their specific needs.
        </p>
        <p>
          From packing your items, to pick-up and return — we're with you every
          step of the way to bring you storage in the easiest way possible.
        </p>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  name: "Achievements",

  data: () => ({}),
};
</script>

<style scoped>
.card-responsive {
  height: 100%;
}
</style>
